import { get, set } from '../local-storage';
import { getStore } from '../store';
import {
  initialSettingsState,
  updateSelectedBaseMapLayer,
} from '../store/modules/app-controls';
import light from './layers/light';
import nautical from './layers/nautical';
import night from './layers/night';
import satellite from './layers/satellite';
import terrain from './layers/terrain';
import treasure from './layers/treasure';

export const updateBaseLayer = (selectedBaseMapLayer) => {
  set('mapStyleService', 'selectedBaseMapLayer', selectedBaseMapLayer);
  getStore().dispatch(updateSelectedBaseMapLayer(selectedBaseMapLayer));
};

export const mapBaseLayerDefinitions = {
  satellite,
  terrain,
  /** This is still called `nautical` instead of `chart` to avoid having to do a DB migration. */
  nautical,
  /** These are still included for the same reason ^. */
  light,
  night,
  treasure,
};

/** These layers are hidden from the map settings menu but still work if a user already has them selected. */
export const HIDDEN_BASE_LAYERS = ['light', 'night', 'treasure'];

export const initialize = async () => {
  const localSetting = await get('mapStyleService', 'selectedBaseMapLayer');
  const selectedBaseMapLayer =
    localSetting || initialSettingsState.selectedBaseMapLayer;

  // Update!
  updateBaseLayer(selectedBaseMapLayer);
};
